<template>
	<div>
		<gross-net-index-returns :widget-data="grossNetReturnData" @open-modal="openingAnnualChart">
			<template #superscript5>
				<disclosure-superscript
					class="detail-page"
					anchor="grossNetReturns"
					:statistics="['NAVYTDDaily', 'NAVCumul1Yr', 'NAVAvg3yr', 'NAVAvg5yr', 'NAVAvg10yr', 'NAVAvgLifetime']"
				/>
			</template>
			<template #superscript4>
				<disclosure-superscript
					class="detail-page"
					anchor="grossNetReturns"
					:statistics="['NAVYTDDaily', 'NAVCumul1Yr', 'NAVAvg3yr', 'NAVAvg5yr', 'NAVAvg10yr', 'NAVAvgLifetime']"
				/>
			</template>
			<template #monthlyIndexSuperscript>
				<disclosure-superscript
					class="detail-page"
					anchor="grossNetReturns_monthlyIndexId"
					:statistics="[monthlyIndexID]"
				/>
			</template>
			<template #quarterlyIndexSuperscript>
				<disclosure-superscript
					class="detail-page"
					anchor="grossNetReturns_quarterlyIndexId"
					:statistics="[quarterlyIndexID]"
				/>
			</template>
			<template #monthlyIndex>
				<i-ball-modal :tag="monthlyIndexID" />
			</template>
			<template #quarterlyIndex>
				<i-ball-modal :tag="quarterlyIndexID" />
			</template>
		</gross-net-index-returns>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import GrossNetIndexReturns from './gross-net-index-returns/GrossNetIndexReturns';
export default {
	name: 'GrossNetIndexReturnsWrapper',
	components: {
		GrossNetIndexReturns
	},
	computed: {
		...mapGetters(['getReturns', 'getFundAttributes']),
		grossNetReturnData() {
			const fundSymbol =
				(this.getFundAttributes && this.getFundAttributes.FundSymbol) ||
				'';
			return {
				monthly: this.getReturns.monthly,
				quarterly: this.getReturns.quarterly,
				primaryLabel: fundSymbol,
				showSubHeader: true
			};
		},
		//do this in the UI (rather than CL like IndexName) to use as disclosure/iBall statistic/tag in the global component
		monthlyIndexID() {
			return `${this.getReturns.monthly?.cgIndexID ?? ''}`;
		},
		quarterlyIndexID() {
			return `${this.getReturns.quarterly?.cgIndexID ?? ''}`;
		}
	},
	methods: {
		openingAnnualChart() {
			const modal = { showModal: true, activeTab: 'annual' };
			this.$store.commit('displayModal', modal);
		}
	}
};
</script>